module.exports = __webpack_public_path__ + "img/8.91cd2ca8.png";